import { useState } from 'react';
import { flushSync } from 'react-dom';

export function usePreventDuplicateCall() {
  const [isProcessing, setIsProcessing] = useState(false);

  const preventDuplicateCall = async <T>(fn: () => Promise<T>): Promise<T | undefined> => {
    if (isProcessing) return; // 중복 호출 방지

    flushSync(() => setIsProcessing(true));
    try {
      return await fn();
    } catch (error) {
      console.dir('Error', error);
    } finally {
      setIsProcessing(false); // 상태 초기화
    }
  };

  return { isProcessing, preventDuplicateCall };
}
